import { gsap, ScrollTrigger } from "@gsap";
/**
 * Layout: Content - Afbeelding
 * Slug: content_afbeelding
 */

document.addEventListener('DOMContentLoaded', function() {
	gsap.registerPlugin(ScrollTrigger);
    const layouts = document.querySelectorAll('.flex-layout.content_afbeelding-layout');

	layouts.forEach((layout) => {
		const contentElements = layout.querySelectorAll(".content-col > *");
		const image = layout.querySelector(".image-col .image-wrapper");
		const shape = layout.querySelector(".image-col > svg");
		let mm = gsap.matchMedia();

		gsap.from(contentElements, {
			opacity: 0,
			stagger: 0.2,
			scrollTrigger: {
				trigger: layout,
				markers: false,
				start: "top center-=10%",
				end: "bottom center"
			}
		});

		mm.add("(min-width: 993px)", () => {
			gsap.from(image, {
				x: -30,
				opacity: 0.9,
				scrollTrigger: {
					trigger: layout,
					markers: false,
					scrub: 1,
					end: "bottom center"
				}
			});
			gsap.from(shape, {
				x: 30,
				opacity: 0.9,
				scrollTrigger: {
					trigger: layout,
					markers: false,
					scrub: 1,
					end: "bottom center"
				}
			});
		});
	});
});
